module.exports = __webpack_public_path__ + "static/media/SDFSA_5-845w.8b45d6c0.webp";